import __request__ from "routing/request";
export function searchAbsolute(query, from, to, limit, offset, filter, streams, fields, sort, decorate = true, requestOptions) {
  return __request__("GET", "/search/universal/absolute", null, { "query": query, "from": from, "to": to, "limit": limit, "offset": offset, "filter": filter, "streams": streams, "fields": fields, "sort": sort, "decorate": decorate }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchAbsoluteChunked(query, from, to, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/absolute", null, { "query": query, "from": from, "to": to, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function exportSearchAbsoluteChunked(query, from, to, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/absolute/export", null, { "query": query, "from": from, "to": to, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
